export enum ActivityEventStatusEnum {
  Open = 10,
  Deleted = 98,
  Closed = 99,
}
